module.exports = __webpack_public_path__ + "public/images/slider/loseva.d5bc8d17762926469c2f3769e323b9ce.png";